import { useEffect, useState, type RefObject } from "react";

/**
 * 요소가 뷰포트에 걸쳐 있는지. 스크롤 위치를 재는 대신 네이티브 IntersectionObserver 로 봐요.
 *
 * @param amount 요소의 몇 할이 보여야 "보인다"로 칠지. @default 0 (한 픽셀이라도)
 */
export function useInViewport(ref: RefObject<Element | null>, amount = 0): boolean {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), {
      threshold: amount,
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, amount]);

  return inView;
}
